export default __webpack_public_path__ + "static/media/FondsDaKu_Logo_sw.128a11f3.png";